import { cn } from '@/lib/utils'
import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/website')({
  component: WebsiteWorkspaceLayout,
})

function WebsiteWorkspaceLayout() {
  const location = useLocation()
  const normalizedPathname = location.pathname.replace(/\/$/, '')
  const isWebsiteBuilderRoute = normalizedPathname.endsWith('/website/builder')

  return (
    <div
      className={cn(
        'flex flex-col',
        isWebsiteBuilderRoute ? 'h-[calc(100dvh-5.5rem)] min-h-0 gap-3 overflow-hidden' : 'gap-6'
      )}
    >
      <div className={cn(isWebsiteBuilderRoute && 'min-h-0 flex-1 overflow-hidden')}>
        <Outlet />
      </div>
    </div>
  )
}
